import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import './Securitytab.css'

import { useAuth } from '../../../firebase/AuthProvider';
import qrcode from "../../../assets/images/qrcode.svg";
import eyecloseicon from "../../../assets/images/eyecloseicon.svg";
import openeyeicon from "../../../assets/images/openeyeicon.svg";
import { toast } from 'react-toastify';
import { changePassword } from '../../../services/userServices/TeamService';
import Loader from '../loader/Loader';
import EmailVerificationPrompt from '../settings/EmailVerificationPrompt';
import { multiFactor } from 'firebase/auth';
import SetupMFAModal from './SetupMFAModal';
import MultiFactorDisableAuthCard from './MultiFactorDisableAuthCard';
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";

const Securitytab = () => {
    const { currentUser } = useAuth();
    const token = (currentUser as any)?.accessToken;
    const Eye = BsFillEyeFill as any;
    const CloseEye = BsFillEyeSlashFill as any;

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState(false);

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors: { [key: string]: string } = {};

        if (!formData.newPassword) newErrors.newPassword = "New password is required.";
        if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm your new password.";

        // Strong password check (adjust regex as needed)
        const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (formData.newPassword && !strongPasswordRegex.test(formData.newPassword)) {
            newErrors.newPassword =
                "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.";
        }

        if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = "New passwords do not match.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!token) {
            toast.error("User not authenticated.");
            return;
        }

        if (!validateForm()) return;
        setLoading(true);
        try {
            const result = await changePassword(formData.newPassword, token);
            if (result) {
                toast.success("Password updated successfully!");
                setFormData({ newPassword: "", confirmPassword: "" });
                setErrors({});
            } else {
                toast.error("Failed to update password. Please try again.");
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}
            <div className="common_content_inner mby_t_24">
                {/* <div className="change_password_flx">
                    <div className="change_password_left">
                        <div className="top top_bar_flx border_tittle">
                            <div className="top_bar_tittle ">

                                <h2>Change Password </h2>
                            </div>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                                        <Form.Label>New Password</Form.Label>
                                        <div className="input_with_icon">
                                            <Form.Control
                                                placeholder="Enter new password"
                                                type={showPassword ? "text" : "password"}
                                                name="newPassword"
                                                value={formData.newPassword}
                                                onChange={handleChange}
                                            />
                                            <img
                                                className="icon_img cursor-pointer"
                                                src={showPassword ? openeyeicon : eyecloseicon}
                                                alt="eyecloseicon"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                            />
                                        </div>
                                        {errors.newPassword && (
                                            <p className="text-red-500 text-sm">{errors.newPassword}</p>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Confirm New Password</Form.Label>
                                        <div className="input_with_icon">
                                            <Form.Control
                                                placeholder="Enter confirm new password"
                                                type={showConfirmPassword ? "text" : "password"}
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={handleChange}
                                            />
                                            <img
                                                className="icon_img cursor-pointer"
                                                src={showConfirmPassword ? openeyeicon : eyecloseicon}
                                                alt="eyecloseicon"
                                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                            />
                                        </div>

                                        {errors.confirmPassword && (
                                            <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
                                        )}
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="form_btn_flx">
                                <Button type="submit" variant="primary">Save</Button>
                            </div>
                        </Form>
                    </div>
                    {!isVerifiry2FA && (
                        <div className="change_password_right">
                            <div className="top top_bar_flx border_tittle">
                                <div className="top_bar_tittle ">
                                    <h2>Multi-Factor Authenticationsss</h2>
                                </div>
                            </div>
                            <div className="maf_content">
                                <div className="maf_content_txt">
                                    <p>Enhance your account security by enabling two-factor authentication.</p>
                                </div>
                                <div className="form_btn_flx">
                                    <Button variant="secondary" onClick={handleShow}>Set up 2FA</Button>
                                </div>
                            </div>
                        </div>
                    )}
                </div> */}
                {/* <div className="maf_btm mby_t_24">
                    <div className="top top_bar_flx border_tittle">
                        <div className="top_bar_tittle ">
                            <h2>Multi-Factor Authentication</h2>
                        </div>
                    </div>
                    <div className="maf_content">
                        <div className="maf_content_txt">
                            <h4>New devices and suspect logins</h4>
                            <p>Enhance your account security by enabling two-factor authentication.</p>
                        </div>
                        <div className="form_btn_flx">
                            <Button variant="primary">Reset</Button>
                        </div>
                    </div>
                </div> */}

                <div className='grid grid-cols-1 xl:grid-cols-2 gap-[20px]'>
                    {/* Left Section: Change Password */}
                    <div style={{
                        flex: 1,
                        border: "1px solid #E5E5E5",
                        borderRadius: "8px",
                        padding: "20px",
                        boxSizing: "border-box"
                    }}>
                        <div style={{ marginBottom: "20px", borderBottom: "1px solid #E5E5E5", paddingBottom: "10px" }}>
                            <h2 className='text-[#1D1D1F] text-[18px] 2xl:text-[22px] font-[500]'>Change Password</h2>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div>
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 500 }}>New Password</Form.Label>
                                    <div style={{ position: "relative" }}>
                                        <Form.Control
                                            placeholder="Enter new password"
                                            type={showPassword ? "text" : "password"}
                                            name="newPassword"
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            style={{
                                                background: "#EFEFEF",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontSize: "14px",
                                                lineHeight: "16px",
                                                letterSpacing: "0px",
                                                width: "100%",
                                                height: "42px",
                                                borderRadius: "12px",
                                                border: "none",
                                                padding: "0 40px 0 10px", // space for eye icon
                                                opacity: 1
                                            }}
                                        />
                                        {/* <img
                                            src={showPassword ? openeyeicon : eyecloseicon}
                                            alt="eye"
                                            onClick={() => setShowPassword(prev => !prev)}
                                            style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                width: "20px",
                                                height: "20px"
                                            }}
                                        /> */}

                                        <div
                                            onClick={() => setShowPassword(prev => !prev)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                                        >
                                            {showPassword ? (
                                                <Eye className="text-[#718096] text-xl" />
                                            ) : (
                                                <CloseEye className="text-[#718096] text-xl" />
                                            )}
                                        </div>
                                    </div>
                                    {errors.newPassword && (
                                        <p style={{ color: "red", fontSize: "12px" }}>{errors.newPassword}</p>
                                    )}
                                </Form.Group>
                            </div>
                            <div>
                                <Form.Group>
                                    <Form.Label style={{ fontWeight: 500 }} className='mt-[20px]'>Confirm Password</Form.Label>
                                    <div style={{ position: "relative" }}>
                                        <Form.Control
                                            placeholder="Enter confirm new password"
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            style={{
                                                background: "#EFEFEF",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontSize: "14px",
                                                lineHeight: "16px",
                                                letterSpacing: "0px",
                                                width: "100%",
                                                height: "42px",
                                                borderRadius: "12px",
                                                border: "none",
                                                padding: "0 40px 0 10px", // space for eye icon
                                                opacity: 1
                                            }}
                                        />
                                        {/* <img
                                            src={showConfirmPassword ? openeyeicon : eyecloseicon}
                                            alt="eye"
                                            onClick={() => setShowConfirmPassword(prev => !prev)}
                                            style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                width: "20px",
                                                height: "20px"
                                            }}
                                        /> */}

                                        <div
                                            onClick={() => setShowConfirmPassword(prev => !prev)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                                        >
                                            {showConfirmPassword ? (
                                                <Eye className="text-[#718096] text-xl" />
                                            ) : (
                                                <CloseEye className="text-[#718096] text-xl" />
                                            )}
                                        </div>
                                    </div>
                                    {errors.confirmPassword && (
                                        <p style={{ color: "red", fontSize: "12px" }}>{errors.confirmPassword}</p>
                                    )}
                                </Form.Group>
                            </div>
                            <div className='flex justify-end w-full'>
                                <div style={{ marginTop: "20px" }}>
                                    <Button type="submit" style={{
                                        backgroundColor: "#7e57c2",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "10px",
                                        padding: "10px 20px",
                                        cursor: "pointer",
                                        fontWeight: 500
                                    }}>
                                        Update
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>


                    {/* Right Section: Multi-Factor Authentication */}
                    {currentUser &&
                        currentUser.emailVerified &&
                        multiFactor(currentUser)?.enrolledFactors?.length === 0 && (
                            <div className='xl:relative' style={{
                                flex: 1,
                                border: "1px solid #E5E5E5",
                                borderRadius: "8px",
                                padding: "20px",
                                boxSizing: "border-box"
                            }}>
                                <div style={{ marginBottom: "20px", borderBottom: "1px solid #E5E5E5", paddingBottom: "10px" }}>

                                    <h2 className='text-[#1D1D1F] text-[18px] 2xl:text-[24px] font-[500]'>Multi-factor Authentication</h2>
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <p className='text-[#676767]'>
                                        Enhance your account security by enabling two-factor authentication.
                                    </p>
                                </div>
                                <Button
                                    className='xl:absolute xl:bottom-[20px] xl:right-[20px] mt-0 xl:mt-10'
                                    onClick={handleShow}
                                    style={{
                                        // distance from right
                                        backgroundColor: "#f9f6ff",
                                        color: "#0A0A0A",
                                        border: "1px solid #7E57C2",
                                        borderRadius: "10px",
                                        padding: "10px 20px",
                                        cursor: "pointer",
                                        fontWeight: 500
                                    }}
                                >
                                    Set up 2FA
                                </Button>
                            </div>
                        )}

                    {
                        currentUser &&
                        currentUser.emailVerified &&
                        multiFactor(currentUser)?.enrolledFactors?.length !== 0 && (
                            <>
                                <MultiFactorDisableAuthCard />
                            </>
                        )
                    }
                </div>

                {currentUser && !currentUser.emailVerified && (
                    <EmailVerificationPrompt user={currentUser} />
                )}
            </div>

            {/* modal */}
            {show && (
                <SetupMFAModal
                    handleClose={handleClose}
                    show={show}
                />
            )}
        </>
    );
};

export default Securitytab;
